<div class="footer-container">
  <div class="footer-content">
    <div class="footer-anno_gestione">
      <span class="anno_gestione-text">XI Anno di Gestione PMO (2025)</span>
    </div>

    <div class="footer-version" *ngIf="isLoggedIn">
      <span
        class="version-badge"
        pTooltip="Clicca per scaricare il changelog"
        tooltipPosition="top"
        (click)="downloadChangelog()"
        [style.cursor]="isDownloading ? 'wait' : 'pointer'">
        v{{ appVersion }}
      </span>
      <!-- Indicatore ambiente di test -->
      <span *ngIf="isTestEnvironment" class="test-environment-footer-badge">
        TEST
      </span>
    </div>
    <div class="footer-logos">
      <a href="https://www.unionemontanavallesusa.it" target="_blank" rel="noopener noreferrer">
        <img src="assets/loghi/UMVS.jpg" alt="UMVS" class="footer-logo">
      </a>
      <a href="http://www.ato3torinese.it" target="_blank" rel="noopener noreferrer">
        <img src="assets/loghi/ato.png" alt="ATO" class="footer-logo">
      </a>
      <a href="https://www.cittametropolitana.torino.it" target="_blank" rel="noopener noreferrer">
        <img src="assets/loghi/provincia.png" alt="Provincia" class="footer-logo">
      </a>
    </div>
    <!-- <div class="footer-copyright">
      <span class="copyright-text">© {{ currentYear }} Vertical Srl - Tutti i diritti riservati</span>
    </div> -->

  </div>
</div>

<p-toast position="top-right"></p-toast>
